import API from "../utils/api";

const getCustomReport  = async (data)   => (await API.post(`/api/reports/custom`, data)).data;
const getDailyReport   = async ()       => (await API.get(`/api/reports/daily`)).data;
const getWeeklyReport  = async ()       => (await API.get(`/api/reports/weekly`)).data;
const getMonthlyReport = async ()       => (await API.get(`/api/reports/monthly`)).data;
const getYearlyReport  = async ()       => (await API.get(`/api/reports/yearly`)).data;

const reportService = {
  getCustomReport,
  getDailyReport,
  getWeeklyReport,
  getMonthlyReport,
  getYearlyReport,
};
export default reportService;